import {Keys} from '../utils/utils';

export enum TaskRelationTypeEnum {
    RelatedTo = 0,
    IsRequiredFor = 1,
    DependsOn = 2,
    IsDuplicateBy = 3,
    Duplicates = 4,
    IsParentFor = 5,
    SubtaskOf = 6,
}


export const TaskRelationTranslationKeys: Record<TaskRelationTypeEnum, string> = {
    [TaskRelationTypeEnum.RelatedTo]: 'crm.task.relation.relatedTo',
    [TaskRelationTypeEnum.IsRequiredFor]: 'crm.task.relation.isRequiredFor',
    [TaskRelationTypeEnum.DependsOn]: 'crm.task.relation.dependsOn',
    [TaskRelationTypeEnum.IsDuplicateBy]: 'crm.task.relation.isDuplicateBy',
    [TaskRelationTypeEnum.Duplicates]: 'crm.task.relation.duplicates',
    [TaskRelationTypeEnum.IsParentFor]: 'crm.task.relation.isParentFor',
    [TaskRelationTypeEnum.SubtaskOf]: 'crm.task.relation.subtaskOf',
}
